import { CountryCode } from 'libphonenumber-js';
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import flags, { CountryFlag } from './flags.js';

/**
 * Flag
 *
 * country - The country code.
 */
@customElement('nn-flag')
export class Flag extends LitElement {
  static styles? = css`
    span {
      display: flex;
      height: 100%;
      justify-content: center;
      width: 100%;
    }

    span img {
      height: auto;
      max-width: var(--nn-flag_span_img_max-width, 48px);
      width: var(--nn-flag_span_img_width, auto);
      object-fit: cover;
    }
  `;

  @property({ type: String }) country: CountryCode = 'FR';

  @property({ type: Object }) flag: CountryFlag | null = null;

  updated(changedProperties: Map<string, string>) {
    if (changedProperties.has('country')) {
      this.flag =
        flags.find(fl => fl.countryCode === this.country.toUpperCase()) ||
        flags[0];
    }
  }

  render() {
    return this.flag
      ? html`
          <span>
            <img
              src="${this.flag.blob}"
              alt="${this.flag.countryCode}"
              aria-hidden="true"
              loading="lazy"
            />
          </span>
        `
      : html`<p>no flag</p>`;
  }
}
